import { api } from '../../lib/api';
import type { HotelDetailDTO, HotelRoomsResponse } from '@pms/shared';

export interface HotelRoomsParams {
  checkIn?: string | undefined;
  checkOut?: string | undefined;
  guests?: number | undefined;
}

export async function getHotel(id: string): Promise<HotelDetailDTO> {
  const { data } = await api.get<HotelDetailDTO>(`/hotels/${id}`);
  return data;
}

export async function getHotelRooms(
  id: string,
  params: HotelRoomsParams,
): Promise<HotelRoomsResponse> {
  const { data } = await api.get<HotelRoomsResponse>(`/hotels/${id}/rooms`, { params });
  return data;
}
